import { useState, useEffect } from 'react';
import { useMsal } from "@azure/msal-react";
import { checkUserRole } from '../utils/authUtils';

export const useAuth = () => {
    const { accounts } = useMsal();
    const [isAdmin, setIsAdmin] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const verifyAdmin = async () => {
            if (accounts[0]) {
                try {
                    setIsLoading(true);
                    const userEmail = accounts[0].username;
                    const adminStatus = await checkUserRole(userEmail);
                    setIsAdmin(adminStatus);
                } catch (error) {
                    console.error('Auth verification failed:', error);
                    setError(error);
                    setIsAdmin(false);
                } finally {
                    setIsLoading(false);
                }
            } else {
                setIsLoading(false);
                setIsAdmin(false);
            }
        };

        verifyAdmin();
    }, [accounts]);

    return { 
        isAdmin, 
        isLoading, 
        error,
        userEmail: accounts[0]?.username || null 
    };
};